/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shipping_International_LabelInputs */

const en_shipping_international_label = /** @type {(inputs: Shipping_International_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`International Shipping Fee`)
};

const es_shipping_international_label = /** @type {(inputs: Shipping_International_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarifa de Envío Internacional`)
};

const fr_shipping_international_label = /** @type {(inputs: Shipping_International_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frais de port internationaux`)
};

const de_shipping_international_label = /** @type {(inputs: Shipping_International_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Internationale Versandkosten`)
};

const id_shipping_international_label = /** @type {(inputs: Shipping_International_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biaya Pengiriman Internasional`)
};

/** @type {(inputs: Shipping_International_LabelInputs) => LocalizedString} */
const ja_shipping_international_label = en_shipping_international_label;

/** @type {(inputs: Shipping_International_LabelInputs) => LocalizedString} */
const zh_shipping_international_label = en_shipping_international_label;

/** @type {(inputs: Shipping_International_LabelInputs) => LocalizedString} */
const ar_shipping_international_label = en_shipping_international_label;

/** @type {(inputs: Shipping_International_LabelInputs) => LocalizedString} */
const it_shipping_international_label = en_shipping_international_label;

/** @type {(inputs: Shipping_International_LabelInputs) => LocalizedString} */
const ru_shipping_international_label = en_shipping_international_label;

/** @type {(inputs: Shipping_International_LabelInputs) => LocalizedString} */
const pt_shipping_international_label = en_shipping_international_label;

/** @type {(inputs: Shipping_International_LabelInputs) => LocalizedString} */
const ko_shipping_international_label = en_shipping_international_label;

/**
* | output |
* | --- |
* | "International Shipping Fee" |
*
* @param {Shipping_International_LabelInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const shipping_international_label = /** @type {((inputs?: Shipping_International_LabelInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shipping_International_LabelInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_shipping_international_label(inputs)
	if (locale === "es") return es_shipping_international_label(inputs)
	if (locale === "fr") return fr_shipping_international_label(inputs)
	if (locale === "de") return de_shipping_international_label(inputs)
	if (locale === "ja") return ja_shipping_international_label(inputs)
	if (locale === "zh") return zh_shipping_international_label(inputs)
	if (locale === "ar") return ar_shipping_international_label(inputs)
	if (locale === "id") return id_shipping_international_label(inputs)
	if (locale === "it") return it_shipping_international_label(inputs)
	if (locale === "ru") return ru_shipping_international_label(inputs)
	if (locale === "pt") return pt_shipping_international_label(inputs)
	return ko_shipping_international_label(inputs)
});